import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion';
import { adMentorAI } from '../assets/images';
import { UserContext } from '../context/UserContext';
const NavbarComponent = () => {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = React.useState(false);
  const { activeUrl, setActiveUrl, userInfo, userMetaInfo } = useContext(UserContext)
  const navigateHandler = (url, isMobileMenu) => {
    if(isMobileMenu){
      setIsOpen(false)
    }
    navigate(url)
    setActiveUrl(url)
  }

  const isActiveUrl = (url) => {
    return activeUrl === url ? 'text-purple-600' : 'text-gray-700'
  }

  return (
    <nav className="bg-white shadow p-2 md:p-4 fixed top-0 left-0 w-full z-50  flex items-center">
        {/* <h1 className="text-2xl font-bold text-blue-600 cursor-pointer" onClick={() => navigateHandler("/")}>AdWiseAI</h1> */}
        <img onClick={() => navigateHandler("/")} src={adMentorAI} alt='admentor ai logo' className='w-40 mb-2 cursor-pointer' />
        
        <div className="flex justify-between items-center max-w-7xl mx-auto">
          <div className="hidden md:flex space-x-4 text-sm md:space-x-6 md:text-base">
            <p onClick={()=>navigateHandler("/")} className={` ${isActiveUrl('/')} cursor-pointer transition`}>Home</p>
            {userInfo?.access && userMetaInfo?.trial?.is_trial && 
              <p onClick={()=>navigateHandler("/Dashboard")} className={` ${isActiveUrl('/Dashboard')} cursor-pointer transition`}>Dashboard</p>
            }
            <p onClick={()=>navigateHandler("/features")} className={`${isActiveUrl('/features')} cursor-pointer transition`}>Features</p>
            <p onClick={()=>navigateHandler("/pricing")} className={`${isActiveUrl('/pricing')} cursor-pointer transition`}>Pricing</p>
            <p onClick={()=>navigateHandler("/contact")} className={`${isActiveUrl('/contact')} cursor-pointer transition`}>Contact</p>
            {userInfo?.access ?
             <p onClick={()=>navigateHandler("/account-page")} className={`text-blue-600 cursor-pointer font-semibold`}>{userInfo?.fullName?.split(' ')?.[0] || userInfo?.fullName}'s Account</p>
              :
             <p onClick={()=>navigateHandler("/login")} className={`text-blue-600 cursor-pointer font-semibold`}>Login</p>
            }
          </div>
        </div>
        <div className="md:hidden">
          <button className="text-blue-600 p-3 text-[30px]" onClick={() => setIsOpen(!isOpen)}>
            ☰
          </button>
        </div>
        <AnimatePresence>
          {isOpen && (
            <>
              <motion.div
                initial={{ x: "100%" }}
                animate={isOpen ? { x: 0 } : { x: "100%" }}
                transition={{ type: "spring", stiffness: 260, damping: 40 }}
                exit={{ x : '100%', opacity: 0}}
                className="fixed h-auto top-0 right-0 bottom-0 w-64 bg-white z-[1000] shadow-lg md:hidden p-6"
              >
                <button
                  className="text-gray-500 text-2xl absolute top-4 right-4"
                  onClick={() => setIsOpen(false)}
                >
                  x
                </button>
                <ul className="mt-12 space-y-6">
                    <li onClick={()=>navigateHandler("/", true)} className={` ${isActiveUrl('/')} cursor-pointer transition`}>Home</li>
                    {userInfo?.access  &&
                      <li onClick={()=>navigateHandler("/Dashboard", true)} className={` ${isActiveUrl('/Dashboard')} cursor-pointer transition`}>Dashboard</li>
                    }
                    <li onClick={()=>navigateHandler("/features", true)} className={`${isActiveUrl('/features')} cursor-pointer transition`}>Features</li>
                    <li onClick={()=>navigateHandler("/pricing", true)} className={`${isActiveUrl('/pricing')} cursor-pointer transition`}>Pricing</li>
                    <li onClick={()=>navigateHandler("/contact", true)} className={`${isActiveUrl('/contact')} cursor-pointer transition`}>Contact</li>
                    {userInfo?.access ?
                    <li onClick={()=>navigateHandler("/account-page", true)} className={`text-blue-600 cursor-pointer font-semibold`}>{userInfo?.fullName?.split(' ')?.[0] || userInfo?.fullName}'s Account</li>
                      :
                    <li onClick={()=>navigateHandler("/login", true)} className={`text-blue-600 cursor-pointer font-semibold`}>Login</li>
                    }
                </ul>
              </motion.div>

              {/* Backdrop */}
              {isOpen && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setIsOpen(false)}
                  className="fixed inset-0 bg-black bg-opacity-30 z-[999] md:hidden"
                ></motion.div>
              )}
            </>
          )}
        </AnimatePresence>
    </nav>

  )
}

export default NavbarComponent